export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getBranchesByServiceProvider>
        <cityCode>${params.cityCode}</cityCode>
        <serviceProviderId>${params.serviceProviderId}</serviceProviderId>
        <serviceType>${params.serviceType}</serviceType>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getBranchesByServiceProvider>
    </soapenv:Body>
  </soapenv:Envelope>
`
